<template>
<div>
    <b-card no-body>
       <b-form inline>
            <b-tabs>
                <b-tab :title="system.label" v-bind:key='system.name' v-for='system in systems'>
                    <b-row v-if="system.admin">
                        <b-col cols="3">{{system.admin.label}}</b-col>
                        <b-col cols="3">
                            <select
                                :data-subsystem-name='system.admin.key' 
                                v-on:change='onSystemLevelSelectChange' class="mb-3">
                                <option v-for='level in system.admin.levels'
                                        v-bind:key='level.name'
                                        v-bind:value='level.value'
                                        v-bind:selected="(userSystemLevels['user_system_levels']
                                            && system.admin.key in userSystemLevels['user_system_levels']
                                            && userSystemLevels['user_system_levels'][system.admin.key] == level.value) || 
                                            (!userSystemLevels['user_system_levels'] && level.value == 0 )">
                                    {{level.name}}
                                </option>
                            </select>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col v-bind:key='subsystem.key' v-for='subsystem in system.subsystems' cols="6">
                            <b-row>
                                <b-col>{{subsystem.label}}</b-col>
                                <b-col>
                                    <select cols=3
                                        :data-subsystem-name='subsystem.key' 
                                        v-on:change='onSystemLevelSelectChange' class="mb-3">
                                        <option v-for='level in subsystem.availableLevels'
                                                v-bind:key='level.name'
                                                v-bind:value='level.value'
                                                v-bind:selected="(userSystemLevels['user_system_levels']
                                                                && subsystem.key in userSystemLevels['user_system_levels']
                                                                && userSystemLevels['user_system_levels'][subsystem.key] == level.value) 
                                                                || (!userSystemLevels['user_system_levels'] && level.value == 0)">
                                            {{level.name}}
                                        </option>
                                    </select>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                </b-tab>
            </b-tabs>
        </b-form>
        <!-- <b-btn>Cancel</b-btn> -->
    </b-card>
</div>
</template>

<script>
import apiService from "@/service/apiService";
import {accessRights} from "@/service/accessRights";


export default {
    computed:{
        userSystemLevels(){
            return this.$store.state.userSystemLevels
        }
    },
    data:function(){
        return {
            systems:accessRights
        }

    },
    methods:{
        onSystemLevelSelectChange:function(a){
            this.$store.dispatch(
                "userSystemLevels/updateSingleUserSystemLevel",
                {
                    name: a.target.dataset['subsystemName'],
                    level: a.target.value
                }
            );  
        },
        onSave:function(){

            var service = new apiService()

            service.updateUserSystemLevels('abc', this.userSystemLevels).then((result)=>{

                this.$root.$emit('bv::refresh::table', 'user-roles-management-list-panel-details-table');

            });

        }
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/account/ui-components/UserRolesManagementDetailPanel.vue